<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5V8AX2/tc-custom/9781504047289.jpg?1706988703504" alt="This image is the cover for the book Sea Jade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sea Jade
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times–</i>bestselling author: In nineteenth-century New England, a desperate young woman’s only refuge becomes an inescapable trap.</b><br/>  <br/> It was fitting that Miranda Heath’s first glimpse of the forbidding home at Bascomb’s Point was in the fury of a thunderstorm. Despite her late father’s caution to steer clear of his friend Obadiah Bascomb’s New England mansion, Miranda, destitute as she was, had no choice but to accept the old captain’s charitable request. Besides, her father and Obadiah’s adventurous past was as much a part of her heritage as their legendary ship, the <i>Sea Jade</i>. But it’s beyond Miranda’s imaginings when she finds herself swept up in an impetuous marriage with a friend of the Bascomb family, a virtual stranger to her.<br/>  <br/> More victim than bride, and at the mercy of her imposing new mother-in-law as well as Obadiah’s mysterious wife and a threatening housekeeper, Miranda fears the invitation to the isolated house was more a matter of revenge than rescue. She has no way of knowing that buried in her own past is the key to a tragic mystery that’s been left to her to solve—if she’s to make it out of Bascomb’s Point alive.<br/>  <br/> The recipient of the Agatha Award for Lifetime Achievement, Phyllis A. Whitney is “a superb and gifted story teller” (Mary Higgins Clark).<br/>  <br/><i>This ebook features an illustrated biography of Phyllis A. Whitney including rare images from the author’s estate.</i><br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phyllis A. Whitney
      </h2>
      
      <p class="authorDescription body article">Born in Yokohama, Japan, on September 9, 1903, Phyllis A. Whitney was a prolific author of award-winning adult and children&rsquo;s fiction. Her sixty-year writing career and the publication of seventy-six books, which together sold over fifty million copies worldwide, established her as one of the most successful mystery and romantic suspense writers of the twentieth century and earned her the title &ldquo;The Queen of the American Gothics.&rdquo;<BR /><BR /> Whitney resided in several places, including New Jersey. She traveled to every location mentioned in her books in order to better depict the settings of her stories. She earned the Mystery Writers of America Grand Master award in 1988, the Agatha in 1990, and the lifetime achievement award from the Society of Midland Authors in 1995. Whitney was working on her autobiography at the time of her passing at the age of 104.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0054513b